<template>
	<b-container>
		<b-breadcrumb :items="breadcrumb" style="margin-top: 15px;"></b-breadcrumb>
		<b-row>
			<b-col></b-col>
			<b-card bg-variant="light" style="margin-top: 15px;">
				<b-form>
					<b-row v-if="loadingWorker">CARGANDO TRABAJADOR</b-row>
					<div class="">
						<!-- <h2 class="title">{{$lang.worker.new}}</h2> -->
						<h2 class="title">Información personal</h2>
						<hr>
						<div class="form-division">
							<label for="id-number">{{$lang.worker.idNumber}}</label>
							<b-form-input id="id-number" v-model="worker.idNumber" type="text" v-mask="['##.###.###-#','#.###.###-#']" masked="false"></b-form-input>
						</div>
						<div class="form-division">
							<label for="first-name">{{$lang.worker.firstName}}</label>
							<b-form-input id="first-name" v-model="worker.firstName" type="text"></b-form-input>
						</div>
						<div class="form-division">
							<label for="last-name">{{$lang.worker.lastName}}</label>
							<b-form-input id="last-name" v-model="worker.lastName" type="text"></b-form-input>
						</div>
						<div class="form-division">
							<label for="email">{{$lang.worker.email}}</label>
							<b-form-input id="email" v-model="worker.email" type="email"></b-form-input>
						</div>
						<div class="form-division">
							<label for="phone-number">{{$lang.worker.phoneNumber}}</label>
							<b-form-input id="phone-number" v-model="worker.phoneNumber" type="text" v-mask="'+## # #### ####'"></b-form-input>
						</div>
						<div class="form-division">
							<label for="birth-date">{{$lang.worker.birthDate}}</label>
							<date-pick v-model="worker.birthDate" class="blockDatePick" :format="dateFormat" :input-attributes="{ class: 'form-control' }"></date-pick>
						</div>
						<div class="form-division">
							<label for="active">{{$lang.worker.workerStatus}}</label>
							<div >
								<p-check class="p-switch p-fill" color="info" v-model="worker.isActive">{{worker.isActive ? $lang.worker.status.active : $lang.worker.status.inactive}}</p-check>
							</div>
						</div>
						<hr> <!-- CONTRACT SECTION -->
						<h4 class="title">{{$lang.contract.title}}</h4>
						<div class="form-division">
							<label for="costCenter">{{$lang.contract.costCenter}}</label>
							<v-select label="name" v-model="worker.contract.costCenter" :options="$store.getters.costCenters" style="background-color: #FFF;" />
						</div>
						<div class="form-division">
							<label for="endDate">{{$lang.contract.salary}}</label>
							<!-- <b-form-input v-model="worker.contract.salary" v-money="money" /> -->
							<money v-model="worker.contract.salary" v-bind="money" class="form-control"></money>
						</div>
						<div class="form-division">
							<label for="contractType">{{$lang.contract.type}}</label>
							<v-select label="name" v-model="worker.contract.type" :options="$store.getters.contractTypes" style="background-color: #FFF;" />
						</div>
						<div class="form-division">
							<label for="contractType">{{$lang.contract.position}}</label>
							<v-select label="name" v-model="worker.contract.position" :options="$store.state.positions" style="background-color: #FFF;" />
						</div>
						<div class="form-division">
							<label for="startDate">{{$lang.contract.startDate}}</label>
							<date-pick v-model="worker.contract.startDate" class="blockDatePick" :format="dateFormat" :input-attributes="{ class: 'form-control' }"></date-pick>
						</div>
						<div class="form-division">
							<label for="endDate">{{$lang.contract.endDate}}</label>
							<date-pick v-model="worker.contract.endDate" class="blockDatePick" :format="dateFormat" :input-attributes="{ class: 'form-control' }"></date-pick>
						</div>
						<hr>
						<div>
							<b-button variant="primary" class="title" block value="Save" v-on:click="createWorker"  >{{$lang.buttons.save}}</b-button>
							<b-button variant="danger"  class="title" block value="Cancel" @click="$router.go(-1)">{{$lang.buttons.cancel}}</b-button>
						</div>
					</div>
				</b-form>
			</b-card>
			<b-col></b-col>
		</b-row>
	</b-container>
</template>

<script>
import { mapState } from 'vuex'

import DatePick from 'vue-date-pick'
import { Money } from 'v-money'
const utils = require('../../utils.js');

export default {
	data() {
		return {
			breadcrumb: [],
			money: utils.moneyConfig,
			dateFormat: utils.dateFormat,
			worker: {
				id: '',
				idNumber: '',
				firstName: '',
				lastName: '',
				birthDate: '',
				phoneNumber: '',
				email: '',
				isActive: false,
				salary: '',
				contract: {
					type: {},
					startDate: '',
					endDate: '',
					salary: '',
					position: {},
					costCenter: {}
				}
			},
		}
	},
	components: {
		DatePick,
		Money
	},
	computed: {
		...mapState(['loadingWorker']),
	},
	methods: {
		createWorker () {
			this.$store.commit('setWorker',this.worker)
			this.$store.dispatch('createWorker', this.worker)
			this.$router.push('/workers')
		},
		createBreadcrumb() {
			this.breadcrumb.push({'text': this.$lang.modules.Workers, 'href': '/workers'})
			this.breadcrumb.push({'text': this.$lang.modules[this.$route.name]})
		}
	},
	beforeMount() {
		this.$Progress.start()
	},
	created() {
		this.$Progress.start()
		if(this.$route.params.workerId) {
			let workerId = this.$route.params.workerId
			this.$store.dispatch('fetchWorker', { workerId }).then( () => {
				this.worker = this.$store.getters.worker;
			} )
		}

		this.$store.dispatch('fetchContractTypes')
		this.$store.dispatch('fetchPositions')
		this.$store.dispatch('fetchCostCenters')

		this.createBreadcrumb()
		this.$Progress.finish()
	}
}

</script>